import { Card, Flex, Tabs } from 'antd'
import { useState } from 'react'

import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { BREADCRUMBS } from 'constants/breadcrumb'
import { FEATURE } from 'constants/feature'
import { usePermission } from 'hooks/use-permission'
import { PTOExistingRewardsTable } from 'modules/pto-rewards/existing-table'
import { PTORewardsCreate } from 'modules/pto-rewards/form-create'
import { PTOWinnerRewardsTable } from 'modules/pto-rewards/winner-rewards-table'

import './styles.scss'

const PTORewards = () => {
  const breadCrumbItems = [BREADCRUMBS.PTO_REWARDS]
  const [activeTab, setActiveTab] = useState('existing')
  const { canCRUD } = usePermission()

  return (
    <Flex vertical gap={24} className="pto-rewards">
      <Breadcrumb additionalItems={breadCrumbItems} />

      <div>
        <div className="main-title" style={{ marginBottom: 8 }}>
          Rewards Management
        </div>
        <div className="main-description">
          Create and manage on-chain rewards for PTO ticket programs
        </div>
      </div>

      {canCRUD(FEATURE.PTO_REWARDS) && <PTORewardsCreate />}

      <Card>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={[
            {
              key: 'existing',
              label: 'Existing Rewards',
              children: <PTOExistingRewardsTable />,
            },
            {
              key: 'winner',
              label: 'Winners List',
              children: <PTOWinnerRewardsTable />,
            },
          ]}
        />
      </Card>
    </Flex>
  )
}

export default PTORewards
